import React from 'react';
import { useDropzone } from 'react-dropzone';
import { X } from 'react-feather';
import { useInternationalization } from '../../features/i18n';
import { ButtonOutline } from '../buttons';
import { FormDashboardLabel as Label } from '../dashboard-form';

const tailwindClasses = 'border border-dashed mb-4 rounded flex justify-center items-center bg-center bg-no-repeat bg-contain cursor-pointer relative'

const DEFAULT_MAX_FILES = 1

const ImageDropzone = ({
  defaultValue,
  // className,
  label,
  height,
  message,
  buttonWidth,
  // returnRaw,
  maxFiles,
  onChange = (e) => { console.log(e) }
}) => {
  const { translate } = useInternationalization()
  const [image, setImage] = React.useState(undefined)

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: 'image/jpeg, image/png',
    maxFiles: maxFiles || DEFAULT_MAX_FILES,
    maxSize: 2000000
  });

  React.useEffect(() => {
    if(defaultValue){
      setImage(defaultValue)
    }
  }, [defaultValue])

  React.useEffect(() => {
    if(acceptedFiles){
      onChange(acceptedFiles)

      if(!maxFiles){
        if(acceptedFiles[0]){
          const blob = URL.createObjectURL(acceptedFiles[0])
          console.log(blob)
          setImage(blob)
        }
      }
    }
    //eslint-disable-next-line
  }, [acceptedFiles])

  const handleRemove = (e) => {
    e.stopPropagation()
    setImage(undefined)

    if(typeof onChange === 'function'){
      onChange(undefined)
    }
  }

  // const acceptedFileItems = acceptedFiles.map(file => (
  //   <li key={file.path}>
  //     {file.path} - {file.size} bytes
  //   </li>
  // ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path} className="border p-2">
      <span>{file.path} - {file.size} bytes</span>
      <ul>
        {errors.map(e => (
          <li key={e.code} className="text-red-600 font-bold">{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  return (
    <section>
      {
        label &&
        <Label>{label}</Label>
      }
      <div {...getRootProps({
        className: `${tailwindClasses}`,
        style: {
          borderColor: '#ddd', height: height ? height : '128px',
          backgroundImage: image ? `url('${image}')` : '',
        }
      })}>
        <input {...getInputProps()} />

        {
          image ? (
            <div
              className="h-8 w-8 p-1 bg-white rounded-full text-sm shadow-md flex justify-center items-center absolute top-0 right-0"
              onClick={handleRemove}
            >
              <X />
            </div>
          ) : (
            <div className="text-center">
              {
                message &&
                <p className="text-xs text-gray-999 mb-3">{message}</p>
              }
              <ButtonOutline
                type="button"
                style={{width: buttonWidth ? buttonWidth : '100%', minWidth: '120px', maxWidth: '160px'}}
              >
                {translate('GENERAL', 'choose_file')}
              </ButtonOutline>
            </div>
          )
        }

      </div>
      {
        (fileRejectionItems && fileRejectionItems.length > 0) &&
        <aside className="border border-red-600 p-2 text-xs">
          {/* <h4>Accepted files</h4>
          <ul>{acceptedFileItems}</ul> */}
          <h4>Rejected files</h4>
          <ul>{fileRejectionItems}</ul>
        </aside>
      }
    </section>
  );
}

export { ImageDropzone }
